import { snakeCasetoText } from 'Shared/helpers';

import { PrivacyType } from '../types';

export function getPrivacyOptions({ assigneeId, assignerId, currentUserId, isEdit }) {
  if ((currentUserId === assigneeId && !isEdit) || assigneeId === assignerId)
    return [PrivacyType.justMe, PrivacyType.meAndATeammate, PrivacyType.groupWorkspace, PrivacyType.everyone];
  return [PrivacyType.meAndChoosenTeammate, PrivacyType.groupWorkspace, PrivacyType.everyone];
}

export function formatOptionsFromArray(options) {
  return options.map(option => ({
    label: snakeCasetoText(option),
    value: option,
  }));
}
